(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-flyout-menu"] && !Shopify.designMode) return;
  try {
    /* ==========================================================================
     MEGA MENU (FLYOUT) — Cinfer
     1) Painéis nunca saem do ecrã: abrem para a esquerda (flip) quando não
        cabem à direita e, em último caso, são encostados à margem.
     2) A barra de categorias encolhe automaticamente (fonte + espaçamentos)
        para caber sempre numa linha, sem scroll lateral.
     ========================================================================== */

  (function () {
    var GUTTER = 12; // margem mínima entre o painel e a borda do ecrã (px)
    var CLOSE_DELAY = 180; // tolerância ao sair do menu com o rato (ms)
    var desktopMQ = window.matchMedia('(min-width: 990px)');

    /* ----------------------------------------------------------------------
       1. POSICIONAMENTO DOS PAINÉIS
       ----------------------------------------------------------------------
       Importante: a largura do painel muda DEPOIS de abrir, no momento em que
       o utilizador passa o rato numa categoria e a coluna de subcategorias
       deixa de estar hidden. Era esse o bug — a verificação só corria no
       'toggle', quando o painel ainda só tinha a coluna estreita. Agora
       reposicionamos sempre que o tamanho do painel muda.
       ---------------------------------------------------------------------- */

    function positionPanel(details) {
      if (!details) return;
      var content = details.querySelector('.flyout-menu__content');
      if (!content) return;

      /* Medimos a partir do <details> (a âncora, que não tem transform) e do
         offsetWidth do painel, em vez de getBoundingClientRect() do painel.
         Motivo: o painel tem uma transição de `transform` e, se medíssemos
         durante a animação, o rect vinha com o deslocamento antigo ainda a
         meio caminho e a decisão saía errada. */
      var anchor = details.getBoundingClientRect();
      var width = content.offsetWidth;
      var viewport = document.documentElement.clientWidth;

      var alignRight = anchor.left + width > viewport - GUTTER;
      var shift = 0;

      if (alignRight) {
        // Não cabe à direita → abre para a esquerda (flip).
        var flippedLeft = anchor.right - width;
        // Se mesmo assim transbordar pela esquerda, encosta-se à margem.
        if (flippedLeft < GUTTER) shift = Math.round(GUTTER - flippedLeft);
      }

      content.classList.toggle('flyout-menu__content--align-right', alignRight);
      content.style.setProperty('--flyout-shift', shift + 'px');
    }

    var panelObserver = null;
    if ('ResizeObserver' in window) {
      panelObserver = new ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
          var details = entry.target.closest('details.flyout-menu');
          if (details && details.open) positionPanel(details);
        });
      });
    }

    /* ----------------------------------------------------------------------
       2. AJUSTE AUTOMÁTICO DA BARRA DE CATEGORIAS
       ----------------------------------------------------------------------
       Calcula um fator de escala (--bar-fit) que multiplica o tamanho de
       letra e os espaçamentos horizontais até tudo caber numa linha.
       O mínimo é definido no editor ("Tamanho mínimo da letra"); abaixo
       disso a barra passa a duas linhas em vez de criar scroll lateral.
       ---------------------------------------------------------------------- */

    function fitBar(bar) {
      var inner = bar.querySelector('.menu-full-bg-bar__inner');
      var list = bar.querySelector('.list-menu--inline');
      if (!inner || !list || !list.children.length) return;
      if (bar.offsetParent === null) return; // barra escondida (mobile)

      // Estado neutro antes de medir.
      bar.classList.remove('menu-full-bg-bar--wrap');
      bar.style.setProperty('--bar-fit', '1');

      var barStyles = getComputedStyle(bar);
      var base = parseFloat(barStyles.getPropertyValue('--flyout-menu-font-size')) || 14;
      var floorSize = parseFloat(barStyles.getPropertyValue('--flyout-menu-font-size-min')) || 11;
      var minScale = Math.min(1, floorSize / base);

      function availableWidth() {
        var s = getComputedStyle(inner);
        return inner.clientWidth - parseFloat(s.paddingLeft) - parseFloat(s.paddingRight) - 2;
      }

      function neededWidth() {
        var total = 0;
        for (var i = 0; i < list.children.length; i += 1) {
          total += list.children[i].getBoundingClientRect().width;
        }
        return total;
      }

      var scale = 1;
      // 4 iterações chegam: nem tudo escala de forma perfeitamente linear
      // (ícones caret, arredondamentos), por isso convergimos.
      for (var i = 0; i < 4; i += 1) {
        var avail = availableWidth();
        var needed = neededWidth();
        if (needed <= avail || scale <= minScale) break;
        scale = Math.max(minScale, scale * (avail / needed));
        bar.style.setProperty('--bar-fit', scale.toFixed(4));
      }

      if (neededWidth() > availableWidth()) {
        bar.classList.add('menu-full-bg-bar--wrap');
      }
    }

    function fitAllBars() {
      document.querySelectorAll('.menu-full-bg-bar').forEach(fitBar);
    }

    /* ----------------------------------------------------------------------
       3. CUSTOM ELEMENT
       ---------------------------------------------------------------------- */

    class FlyoutMenu extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.details = this.closest('details.flyout-menu');
        this.primaryItems = Array.from(this.querySelectorAll('.flyout-menu__col-item'));
        this.secondaryPanels = Array.from(this.querySelectorAll('.flyout-menu__col--secondary'));

        this.primaryItems.forEach(
          function (item) {
            item.addEventListener('mouseenter', this.showPanel.bind(this, item.dataset.index));
            var link = item.querySelector('a');
            if (link) link.addEventListener('focus', this.showPanel.bind(this, item.dataset.index));
          }.bind(this)
        );
      }

      showPanel(index) {
        if (this.secondaryPanels.length === 0) return;

        this.secondaryPanels.forEach(function (panel) {
          if (panel.dataset.panel === index) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });

        this.primaryItems.forEach(function (item) {
          item.classList.toggle('active', item.dataset.index === index);
        });

        // O painel acabou de mudar de largura → reavaliar a posição.
        positionPanel(this.details);
      }

      reset() {
        this.secondaryPanels.forEach(function (panel) {
          panel.setAttribute('hidden', '');
        });
        this.primaryItems.forEach(function (item) {
          item.classList.remove('active');
        });
      }
    }

    if (!customElements.get('flyout-menu')) {
      customElements.define('flyout-menu', FlyoutMenu);
    }

    /* ----------------------------------------------------------------------
       4. INICIALIZAÇÃO
       ---------------------------------------------------------------------- */

    function initFlyoutMenus() {
      document.querySelectorAll('details.flyout-menu').forEach(function (details) {
        var content = details.querySelector('.flyout-menu__content');
        if (content && panelObserver) panelObserver.observe(content);

        if (details.dataset.flyoutBound === 'true') return;
        details.dataset.flyoutBound = 'true';

        // Pequeno atraso ao fechar: dá margem para o rato atravessar as
        // bordas entre a categoria da barra, a coluna de subcategorias e a
        // coluna de subsubcategorias sem o menu fechar por baixo do cursor.
        var closeTimer = null;

        function cancelClose() {
          if (closeTimer) {
            clearTimeout(closeTimer);
            closeTimer = null;
          }
        }

        // Abrir ao passar o rato (só desktop); fechar ao sair.
        details.addEventListener('mouseenter', function () {
          if (!desktopMQ.matches) return;
          cancelClose();
          details.open = true;
        });

        details.addEventListener('mouseleave', function () {
          if (!desktopMQ.matches) return;
          cancelClose();
          closeTimer = setTimeout(function () {
            closeTimer = null;
            details.open = false;
          }, CLOSE_DELAY);
        });

        details.addEventListener('toggle', function () {
          var panel = details.querySelector('flyout-menu');

          if (!details.open) {
            cancelClose();
            // Ao fechar, repõe o estado inicial (nada selecionado).
            if (panel && panel.reset) panel.reset();
            return;
          }

          positionPanel(details);
        });
      });

      fitAllBars();
    }

    function onReady(fn) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fn);
      } else {
        fn();
      }
    }

    onReady(initFlyoutMenus);

    // As fontes só carregam depois — as larguras mudam, por isso remedimos.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(fitAllBars);
    }
    window.addEventListener('load', fitAllBars);

    // Redimensionar / zoom: reajusta a barra e reposiciona painéis abertos.
    var resizeRaf = null;
    window.addEventListener('resize', function () {
      if (resizeRaf) cancelAnimationFrame(resizeRaf);
      resizeRaf = requestAnimationFrame(function () {
        fitAllBars();
        document.querySelectorAll('details.flyout-menu[open]').forEach(positionPanel);
      });
    });

    // Editor de temas: a secção é re-renderizada sem recarregar a página.
    document.addEventListener('shopify:section:load', initFlyoutMenus);
  })();
  } catch(e) { console.error(e); }
})();

})();
